import { User } from '@supabase/supabase-js';
import { SubscriptionPlan } from './payment/types';

// SHA-256 해시 함수
async function sha256(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

/**
 * 틱톡 사용자 식별 (identify) 이벤트를 전송합니다.
 * @param user - Supabase 사용자 객체
 */
export const tiktokIdentify = async (user: User) => {
  if (typeof window.ttq === 'undefined' || !user) return;

  try {
    const payload: { email?: string; external_id?: string } = {};

    if (user.email) {
      payload.email = await sha256(user.email);
    }
    payload.external_id = await sha256(user.id);

    window.ttq.identify(payload);
    console.log('TikTok Identify event sent:', payload);
  } catch (error) {
    console.error('Error sending TikTok Identify event:', error);
  }
};

/**
 * 틱톡 무료 체험 시작 (StartTrial) 이벤트를 전송합니다.
 * @param plan - 구독 플랜 정보
 */
export const tiktokTrackStartTrial = (plan: SubscriptionPlan) => {
  if (typeof window.ttq === 'undefined' || !plan) return;

  try {
    window.ttq.track('StartTrial', {
      contents: [
        {
          content_id: plan.id,
          content_type: 'product',
          content_name: plan.name,
        },
      ],
      value: 0,
      currency: 'KRW',
    });
    console.log('TikTok StartTrial event sent for plan:', plan.name);
  } catch (error) {
    console.error('Error sending TikTok StartTrial event:', error);
  }
};

/**
 * 틱톡 구독 (Subscribe) 이벤트를 전송합니다.
 * @param plan - 구독 플랜 정보
 */
export const tiktokTrackSubscribe = (plan: SubscriptionPlan) => {
  if (typeof window.ttq === 'undefined' || !plan) return;

  try {
    window.ttq.track('Subscribe', {
      contents: [
        {
          content_id: plan.id,
          content_type: 'product',
          content_name: plan.name,
        },
      ],
      value: plan.price,
      currency: 'KRW',
    });
    console.log('TikTok Subscribe event sent for plan:', plan.name);
  } catch (error) {
    console.error('Error sending TikTok Subscribe event:', error);
  }
};
